import React from 'react';
import { Button, ButtonProps, Tooltip } from 'antd';

interface ActionButtonProps extends ButtonProps {
  label?: string;
  disabled: boolean;
  disabledMessage: string | null | undefined;
}

const ActionButton: React.FC<ActionButtonProps> = ({
  label,
  disabled,
  disabledMessage,
  ...buttonProps
}) => {
  return (
    <Tooltip title={disabledMessage} destroyOnHidden={false}>
      <Button disabled={disabled} {...buttonProps}>
        {label}
      </Button>
    </Tooltip>
  );
};

export default ActionButton;
